/**
 * Portal shell tenant logo — uses @shared/auth cache + fetch (same as microservices)
 */

import { useTenantLogo } from '@shared/auth';
import { useAuthStore } from '@/stores/authStore';
import { getTenantAuthStorage } from '@/utils/authStorage';
import { config } from '@shared/config';

function resolveTenantUser() {
  const fromStore = useAuthStore.getState().user;
  if (fromStore?.userType === 'tenant-user' && fromStore.tenantId) return fromStore;
  const fromStorage = getTenantAuthStorage().getUser();
  if (fromStorage?.userType === 'tenant-user' && fromStorage.tenantId) return fromStorage;
  return null;
}

export function useTenantPortalLogo(): string | undefined {
  const storeUser = useAuthStore((s) => s.user);
  const user = storeUser?.userType === 'tenant-user' ? storeUser : resolveTenantUser();
  const { tenantLogo } = useTenantLogo(user, {
    portalApiUrl: config.portalApiUrl,
    storage: getTenantAuthStorage(),
  });
  return tenantLogo;
}
